import React from 'react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { iconButtonStyles } from '../../utils/classNames';

interface HelpButtonProps {
  onClick: () => void;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  tooltip?: string;
}

const HelpButton: React.FC<HelpButtonProps> = ({
  onClick,
  size = 'md',
  className = '',
  tooltip = 'ヘルプを表示',
}) => {
  const sizeMap = {
    sm: { button: '44' as const, icon: 'h-4 w-4' },
    md: { button: '44' as const, icon: 'h-5 w-5' },
    lg: { button: '48' as const, icon: 'h-6 w-6' },
  };

  const sizeConfig = sizeMap[size];

  return (
    <button
      onClick={onClick}
      className={`${iconButtonStyles('ghost', sizeConfig.button, 'rounded-full')} ${className}`}
      title={tooltip}
      aria-label={tooltip}
    >
      <QuestionMarkCircleIcon className={`${sizeConfig.icon} text-blue-600 dark:text-blue-400`} />
    </button>
  );
};

export default HelpButton;
